<fieldset
  class="radio-group"
  [class.radio-group--error]="control.invalid && control.touched"
  [class.radio-group--fit]="field.fitContent"
  [class.radio-group--cards]="field.radioCards"
>

  <legend class="radio-group__legend caption">
    {{ field.label }}
    @if (field.required) {
      <span class="required-asterisk" aria-hidden="true"> *</span>
    }
  </legend>

  <div class="radio-group__options">
    @for (option of normalizedOptions; track option.value; let i = $index) {
      <label
        class="radio-option"
        [class.radio-option--disabled]="option.disabled || control.disabled"
        [class.radio-option--salvata]="isSalvata(option.value)"
        [for]="optionId(i)"
      >
        <input
          type="radio"
          class="radio-option__input"
          [id]="optionId(i)"
          [name]="groupId"
          [value]="option.value"
          [formControl]="control"
        />
        <span class="radio-option__custom"></span>
        <span class="radio-option__label">
          {{ option.label }}
          @if (isSalvata(option.value)) {
            <span class="sr-only">(attuale)</span>
          }
        </span>
      </label>
    }
  </div>

</fieldset>
